import BetaManagerApi from "../api/BetaManagerApi";

interface BetaManagerPlayerProfileResponse {
    UserId: string;
    UserName: string,
    PlayerGroups: BetaManagerPlayerGroup[]
}

interface BetaManagerPlayerGroup {
    PlayerGroupId: number,
    Tags: string,
    PlatformId: number,
    IsApproved: boolean,
    IsBanned: boolean,
    CountryCode: string,
    PlayerSourceIds: number[],
    DateApprovedAction: string,
    PlayerSystemInfo: {
        Components: {
            [key: string]: string
        }
    }
}

export default class BetaManagerService {
    static getPlayerProfile = (ticket: string, sessionId: string, userId: string, code: string, phaseId: number) => {
        return BetaManagerApi.get<BetaManagerPlayerProfileResponse>(
            `/api/v1/${code}/phases/${phaseId}/players/${userId}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Ubi-GenomeId': process.env.REACT_APP_GENOME_ID,
                    'Ubi-Ticket': ticket,
                    'Ubi-SessionId': sessionId,
                }
            }
        );
    };

    static registerPlayer = (ticket: string, sessionId: string, userId: string, code: string, phaseId: number, playerGroupId: number, cta: string) => {
        return BetaManagerApi.post<BetaManagerPlayerProfileResponse>(
            `/api/v1/${code}/phases/${phaseId}/players/${userId}/playerGroups/${playerGroupId}`,
            {
                PlayerSystemInfo: {
                    Components: {
                        CTA: cta
                    }
                }
            },
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Ubi-GenomeId': process.env.REACT_APP_GENOME_ID,
                    'Ubi-Ticket': ticket,
                    'Ubi-SessionId': sessionId,
                }
            }
        );
    };
}